module.exports = __webpack_public_path__ + "img/right_hover.539a2c7e.svg";